/**
 * 文档 http://code.ciaoca.com/javascript/exif-js/
 *
 */

export default {
    /**
     * 获取图像的全部数据，值以对象的方式返回
     * @param {*} imageSrc 图片url
     * @param {*} callback
     */
    getAllTags(imageSrc, callback = function () {}) {
        /*eslint-disable*/
        const EXIFTool = EXIF;
        if (EXIFTool) {
            let img = new Image();
            img.crossOrigin = 'anonymous';
            img.src = imageSrc;
            img.onload = function () {
                EXIFTool.getData(img, () => {
                    let allTags = EXIF.getAllTags(img);
                    console.log(allTags);
                    if (typeof callback === 'function') {
                        callback(allTags);
                    }
                });
            };
        }
    },
    /**
     * 获取图像的全部数据，值以字符串的方式返回
     * @param {*} imageSrc 图片url
     * @param {*} callback
     */
    pretty(imageSrc, callback = function () {}) {
        /*eslint-disable*/
        const EXIFTool = EXIF;
        if (EXIFTool) {
            let img = new Image();
            img.crossOrigin = 'anonymous';
            img.src = imageSrc;
            img.onload = function () {
                EXIFTool.getData(img, () => {
                    let pretty = EXIF.pretty(img);
                    if (typeof callback === 'function') {
                        callback(pretty);
                    }
                });
            };
        }
    },
    /**
     * 获取图像的GPS信息 与相机型号，相机生产者
     * @param {*} imageSrc 图片url
     * @param {*} callback
     */
    getGPS(imageSrc, callback = function () {}) {
        /*eslint-disable*/
        const EXIFTool = EXIF;
        if (EXIFTool) {
            let img = new Image();
            img.crossOrigin = 'anonymous';
            img.src = imageSrc;
            img.onload = function () {
                EXIFTool.getData(img, () => {
                    let GPSLongitude = EXIF.getTag(img, 'GPSLongitude');
                    let GPSLatitude = EXIF.getTag(img, 'GPSLatitude');
                    let Make = EXIF.getTag(img, 'Make');
                    let Model = EXIF.getTag(img, 'Model');
                    


                    let longitude = '';
                    let latitude = '';
                    if (GPSLongitude) {
                        longitude = GPSLongitude[0] + GPSLongitude[1] / 60 + GPSLongitude[2] / 60 / 60;
                    }
                    if (GPSLatitude) {
                        latitude = GPSLatitude[0] + GPSLatitude[1] / 60 + GPSLatitude[2] / 60 / 60;
                    }

                    let data = {
                        GPSLongitude: GPSLongitude,
                        GPSLatitude: GPSLatitude,
                        longitude,
                        latitude,
                        Make,
                        Model,
                    };
                    if (typeof callback === 'function') {
                        callback(data);
                    }
                });
            };
        }
    },
    /**
     * 获取图像的某个数据
     * @param {*} imageSrc 图片url
     * @param {*} tag
     * @param {*} callback
     */
    getTag(imageSrc, tag, callback = function () {}) {
        /*eslint-disable*/
        const EXIFTool = EXIF;
        if (EXIFTool) {
            let img = new Image();
            img.crossOrigin = 'anonymous';
            img.src = imageSrc;
            img.onload = function () {
                EXIFTool.getData(img, () => {
                    let tagData = EXIF.getTag(img, tag);
                    if (typeof callback === 'function') {
                        callback(tagData);
                    }
                });
            };
        }
    },
    /**
     * 获取图像的尺寸
     * @param {*} imageSrc 图片url
     * @param {*} callback
     */

     getImageSize(imageSrc, callback) {
        const img = new Image();
        img.onload = function() {
          callback({
            width: img.width,
            height: img.height
          });
        };
        img.onerror = function() {
          console.error('Failed to load image');
        };
        img.src = imageSrc;
      },


    // 根据给定的中心经纬度和距离计算第二个点的经纬度
    calculateLatLng(centerLng, centerLat, distance, type) {
        console.log('calculateLatLng', centerLng, centerLat, distance);
        var R = 6371; // 地球半径，单位为千米
        var dLat = distance / R; // 将距离转换为弧度
        var dLng = dLat * Math.cos(centerLat * (Math.PI / 180)); // 计算经度差
        var lat = null;
        var lng = null;
        if (type < 3) {
            lat = type === 0 ? centerLat : centerLat + dLat; // 计算纬度差
            lng = type === 0 ? centerLng + dLng : centerLng; // 计算经度
        }
        // else {
        //     lat = type === 2 ? centerLat : centerLat - dLat; // 计算纬度差
        //     lng = type === 2 ? centerLng - dLng : centerLng; // 计算经度
        // }

        let lng2 = Math.round(lng * (180 / Math.PI) * 100) / 100; // 将经度从弧度转换回度（保留两位小数）
        var lat2 = Math.round(lat * (180 / Math.PI) * 100) / 100; // 将纬度从弧度转换回度（保留两位小数）
        return [lng2, lat2];
    },
    
    calculateLatLng2(centerLng, centerLat, distance, type) {
        var R = 6371; // 地球半径，单位为千米
        var dLat = distance / R; // 将距离转换为弧度
        var dLng = dLat * Math.sin(centerLat * (Math.PI / 180)); // 计算经度差
        var lat = null;
        var lng = null;
        if (type < 2) {
            lat = type === 0 ? centerLat : centerLat + dLat; // 计算纬度差
            lng = type === 0 ? centerLng + dLng : centerLng; // 计算经度
        }
        // else {
        //     lat = type === 2 ? centerLat : centerLat - dLat; // 计算纬度差
        //     lng = type === 2 ? centerLng - dLng : centerLng; // 计算经度
        // }

        let lng2 = Math.round(lng * (180 / Math.PI) * 100) / 100; // 将经度从弧度转换回度（保留两位小数）
        var lat2 = Math.round(lat * (180 / Math.PI) * 100) / 100; // 将纬度从弧度转换回度（保留两位小数）
        return [lng2, lat2];
    },
};
